import type { GivingContentObjectDetail } from 'models';
import { Avatar, Card, Col, DetailsCategoryItem, Icon, Row } from 'ui';
import { images } from 'common/utils';

type P = { givingContentObject: GivingContentObjectDetail };

const GivingDetailsCard = ({
  givingContentObject: {
    organization,
    postInCommunities: [community],
  },
}: P) => (
  <Card title={<Card.Title icon={<Icon icon="information-line" />}>Details</Card.Title>}>
    <Row gutter={[0, 'ms']}>
      <Col span={24}>
        <DetailsCategoryItem
          category="Organization"
          icon={
            <Avatar
              alt="Organization profile photo"
              fallbackPhoto={images.default.organizationProfilePhoto}
              src={organization.squareLogo ?? organization.profilePhoto}
            />
          }
          name={organization.name}
        />
      </Col>
      <Col>
        <DetailsCategoryItem
          category="Community"
          icon={
            <Avatar
              alt="Community profile photo"
              fallbackPhoto={images.default.communityProfilePhoto}
              src={community.profilePhoto}
            />
          }
          name={community.name}
        />
      </Col>
    </Row>
  </Card>
);

export default GivingDetailsCard;
